import {
  ApplicationRef,
  Component,
  createComponent,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewChild,
  ViewContainerRef
} from "@angular/core";
import { Subscription } from "rxjs";
import { ReportDesignerItemCustom } from "../../report-design-item";
import { ReportDesignerCustomComponentInstance } from "../../report-designer/report-designer-custom-component-instance";

@Component({
  selector: "snt-report-form-renderer-custom",
  templateUrl: "report-form-renderer-custom.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererCustomComponent {
  @Input() item!: ReportDesignerItemCustom;

  @Output() config: EventEmitter<any> = new EventEmitter();

  @Output() action: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild("container", { read: ViewContainerRef })
  containerRef!: ViewContainerRef;

  componentInstance!: ReportDesignerCustomComponentInstance;

  private dataSubscription: Subscription | undefined;
  private actionSubscription: Subscription | undefined;

  private readonly applicationRef = inject(ApplicationRef);

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.containerRef.clear();

      /*
      const componentRef = createComponent(this.item.component, {
        environmentInjector: this.applicationRef.injector,
        hostElement: this.containerRef.element.nativeElement!
      });

       */

      const componentRef =
        this.containerRef.createComponent<ReportDesignerCustomComponentInstance>(
          this.item.component,
          {
            injector: this.applicationRef.injector
          }
        );

      this.componentInstance = <ReportDesignerCustomComponentInstance>(
        componentRef.instance
      );

      this.componentInstance.item = this.item;

      if (this.componentInstance.data$) {
        this.dataSubscription = this.componentInstance.data$.subscribe(
          (data) => {
            this.config.emit(data);
          }
        );
      }

      if (this.componentInstance.action$) {
        this.actionSubscription = this.componentInstance.action$.subscribe(
          (action) => {
            this.action.emit(action);
          }
        );
      }
    }, 0);
  }

  ngOnDestroy(): void {
    this.dataSubscription?.unsubscribe();
    this.actionSubscription?.unsubscribe();
  }
}
